'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'jet-fighter-up';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e518';
var svgPathData = 'M270.6 9.5C268.1 3.7 262.3 0 256 0s-12.1 3.7-14.6 9.5L181.5 144.2c-3.6 8.2-5.5 17-5.5 26l0 40-.4 .3L32 299.3 32 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56 0 40 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 144 0 0 3.4-42.2 66.8c-3.8 6-5.8 13-5.8 20.1c0 20.8 16.9 37.7 37.7 37.7l180.6 0c20.8 0 37.7-16.9 37.7-37.7c0-7.1-2-14.1-5.8-20.1L336 387.4l0-3.4 144 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-40 0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 27.3L336.4 210.4l-.4-.3 0-40c0-9-1.9-17.8-5.5-26L270.6 9.5zM480 352l-144 0 0-104.2 144 89.1 0 15.1zm-304 0L32 352l0-15.1 144-89.1L176 352zm34.8-194.8L256 55.4l45.2 101.8c1.8 4.1 2.8 8.5 2.8 13L304 392c0 3 .9 6 2.5 8.5l44.6 70.7c.6 .9 .9 2 .9 3.1c0 3.2-2.6 5.7-5.7 5.7L272 480l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-74.3 0c-3.2 0-5.7-2.6-5.7-5.7c0-1.1 .3-2.1 .9-3.1l44.6-70.7c1.6-2.6 2.5-5.5 2.5-8.5l0-221.8c0-4.5 .9-8.9 2.8-13z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJetFighterUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;